const TOOLTIP_GAP = 8;
const VIEWPORT_MARGIN = 8;

export interface WebEditorTooltipPositionInput {
  target: { left: number; right: number; top: number; bottom: number; width: number };
  tooltipWidth: number;
  tooltipHeight: number;
  viewportWidth: number;
  viewportHeight: number;
}

export const webEditorTooltipPosition = (input: WebEditorTooltipPositionInput) => {
  const centered = input.target.left + input.target.width / 2 - input.tooltipWidth / 2;
  const maximumLeft = Math.max(VIEWPORT_MARGIN, input.viewportWidth - input.tooltipWidth - VIEWPORT_MARGIN);
  const left = Math.min(
    maximumLeft,
    Math.max(VIEWPORT_MARGIN, centered),
  );
  const fitsBelow = input.target.bottom + TOOLTIP_GAP + input.tooltipHeight <= input.viewportHeight - VIEWPORT_MARGIN;
  return {
    left,
    top: fitsBelow
      ? input.target.bottom + TOOLTIP_GAP
      : Math.max(VIEWPORT_MARGIN, input.target.top - input.tooltipHeight - TOOLTIP_GAP),
    placement: fitsBelow ? 'bottom' : 'top',
  } as const;
};
